import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";
import locales from "../locales/index";
import registerGlobalEventHandlers from "../utils/globalEventHandlers";
import { getLanguageAndRegionFromLocale, getLocaleFromUrl } from "../utils/locale.utils";
import rootReducer from "./reducers";

const __COOKIEWALL_STATE__ = "__COOKIEWALL_STATE__";
const intlData = window[__COOKIEWALL_STATE__];
delete window[__COOKIEWALL_STATE__];

let initialState = {};
if (intlData) {
  initialState = {
    locale: {
      ...getLanguageAndRegionFromLocale(intlData.locale),
      availableLocales: Object.keys(locales)
    }
  };
} else {
  initialState = {
    locale: {
      ...getLocaleFromUrl(),
      availableLocales: Object.keys(locales)
    }
  };
}
const enhancers = [];
const middleware = [thunk];

if (process.env.NODE_ENV === "development") {
  //@ts-ignore
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === "function") {
    //@ts-ignore
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers: any = compose(
  applyMiddleware(...middleware),
  ...enhancers
);

const store = createStore(rootReducer, initialState, composedEnhancers);
registerGlobalEventHandlers(store);
export default store;
